export const CP_IN_PROGRESS_STATUSES =
  'pending_funding,funded,draft,pending_approval,approved,submitted,processing';
